import { type ILatLon, type ILatLonBounds, type ILatLonBoundsProps } from './Types/MapTypes'

type ILatLonBoundsArr = [number, number, number, number]

class LatLonBounds implements ILatLonBounds {
  sw: ILatLon
  ne: ILatLon
  constructor (props: ILatLonBoundsProps) {
    this.sw = { ...props.sw }
    this.ne = { ...props.ne }
  }

  public set (props: ILatLonBoundsProps): void {
    this.sw = { ...props.sw }
    this.ne = { ...props.ne }
  }

  public get (): ILatLonBoundsProps {
    return {
      sw: { ...this.sw },
      ne: { ...this.ne }
    }
  }

  public fromArray (a: ILatLonBoundsArr): void {
    this.set({
      sw: {
        lon: a[0],
        lat: a[1]

      },
      ne: {
        lon: a[2],
        lat: a[3]
      }
    })
  }

  public toArray (): ILatLonBoundsArr {
    // [-78, 33, -74, 35]
    const { sw, ne } = this
    return [
      sw.lon,
      sw.lat,
      ne.lon,
      ne.lat
    ]
  }

  public toStr (): string {
    return this.toArray().join(',')
  }

  public toGeoJson (): GeoJSON.FeatureCollection {
    const { sw, ne } = this
    return {
      type: 'FeatureCollection',
      features: [
        {
          properties: {
            soutWestLat: sw.lat,
            southWestLon: sw.lon,
            northEastLat: ne.lat,
            northEastLon: ne.lon
          },
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [[
              [sw.lon, sw.lat],
              [sw.lon, ne.lat],
              [ne.lon, ne.lat],
              [ne.lon, sw.lat],
              [sw.lon, sw.lat]
            ]]
          }
        }
      ]
    }
  }
}

export default LatLonBounds
